import React from "react";

const LeftAuthPanel = () => {
  return (
    <div className="flex min-h-full w-full flex-col space-y-10 bg-[url('https://res.cloudinary.com/dgqfojhx4/image/upload/v1741691580/dashboard-assets/login-home_r721oa.svg')] bg-contain bg-right bg-no-repeat px-5 pt-14 md:w-1/2 md:justify-center md:px-20">
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        className="flex items-start space-x-2 font-semibold capitalize text-white"
      >
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 4L11 15L8 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <div>
          <h1 className="text-2xl">Instant product deployment</h1>
          <p className="w-4/5 font-normal text-white">
            In minutes, without ops, build websites and campaigns
          </p>
        </div>
      </div>
      <div
        data-aos="fade-up"
        data-aos-duration="1500"
        className="flex items-start space-x-2 font-semibold capitalize text-white opacity-90"
      >
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 4L11 15L8 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <div>
          <h1 className="text-2xl">Quick Product Rollout</h1>
          <p className="w-4/5 font-normal text-white">
            Worry no more about server configurations; just start developing.
          </p>
        </div>
      </div>
      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        className="flex items-start space-x-2 font-semibold capitalize text-white opacity-70"
      >
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 4L11 15L8 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <div>
          <h1 className="text-2xl">Team Collaboration</h1>
          <p className="w-4/5 font-normal text-white">
            Together is better. With invite links, onboard your team.
          </p>
        </div>
      </div>
      <div
        data-aos="fade-up"
        data-aos-duration="2500"
        className="flex items-start space-x-2 font-semibold capitalize text-white opacity-50"
      >
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 4L11 15L8 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <div>
          <h1 className="text-2xl">Shortcuts at your finger tips</h1>
          <p className="w-4/5 font-normal text-white">
            Providing quick and easy access to deployment functions
          </p>
        </div>
      </div>
      <div
        data-aos="fade-up"
        data-aos-duration="3000"
        className="flex items-start space-x-2 font-semibold capitalize text-white opacity-30"
      >
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 4L11 15L8 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <div>
          <h1 className="text-2xl">Automated Builds</h1>
          <p className="w-4/5 font-normal text-white">
            Whenever you push to Git, Brimble detects and triggers auto-deploy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeftAuthPanel;
